<script setup lang="ts">
interface Props {
  error: Object;
}
interface IError{
  url: string
  statusCode: number
  statusMessage: string
  message: string
  description: string
  data: any
}
const props = defineProps<{
    error: IError
}>();
</script>

<template>
    <div class="navbar is-fixed-top pc-header hide_pc_global_menu" >
        <div class="columns is-vcentered is-mobile" :style="{ width: '100%' }">
            <div class="column is-2-desktop is-10-touch">
                <nuxt-link to="/user/mypage">
                    <img src="~/assets/img/core-space-logo.png" class="core-space-logo m-3" />
                </nuxt-link>
            </div>
        </div>
    </div>
    <div id="main-area" class="container content">
        <div class="error-msg">
            <div class="text-center fw-bold my-5 " style="font-size: 2rem; line-height: 1;">
                <h1 v-if="props.error.statusCode == 404">Not Found <br/>404</h1>
                <h1 v-else>{{ props.error.statusCode }}</h1>
            </div>

            <div>
                <span v-if="props.error.statusCode == 404">
                    お探しのページが見つかりません。<br />
                    URLに誤りがあるか、お探しのページは移動もしくは削除された可能性があります。
                </span>
                <span v-else>{{ props.error.message }}</span>

            </div>
            <div>
            <nuxt-link class="home-return-link" to="/user/mypage">戻る</nuxt-link>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.error-msg {
  text-align: center;
  padding: 30px;
}
.home-return-link {
  display: inline-block;
  margin-top: 12px;
  font-weight: 600;
  padding: 12px;
  background-color: white;
  border-radius: 8px;
  &:hover {
    background-color: rgba(128, 128, 128, 0.5);
  }
}
#main-area {
  padding-top: 74px;
}

</style>
